<template>
  <div class="selections-container-phone w-100">
    <div class="d-flex justify-content-center align-items-center">
      <div class="d-flex flex-column justify-content-between align-items-start w-100">
        <span class="merriweather-bold-p16 w-100 text-center pb-3">Notre sélection</span>
        <div class="selection-section px-4 py-3">
          <div
            v-for="selection in selections"
            :key="selection[0]"
            @click="goToSelection(selection[1])"
          >
            <div
              class="raleway-medi-p15 text-center item-link"
            >
              {{ selection[0] }}
            </div>
          </div>
        </div>

        <div class="align-items-center all-selections d-flex justify-content-center pt-4 w-100">
          <a href="/reservation-hotel" class="hortense-btn-primary raleway-bold-p" target="_blank">Tous nos hébergements</a>
        </div>
        <div class="w-100 d-flex justify-content-center align-items-center py-5">
          <img
            src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Notre+se%CC%81lection.jpg"
            alt="Selections"
            class="img-selection"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'SelectionsList',
  data() {
    return {
      selections: [
        ["Nos hôtels", "/hotel-de-charme"],
        ["Nos chambres d'hôtes", "/chambres-dhotes-de-charme"],
        ["Nos maisons et villas", "/villa-de-charme"],
        ["Nos lieux insolites", "/logement-insolite-de-luxe"],
        ["Nos chalets", "/chalet"],
        ["Nos appartements", "/appartement-de-vacances"]
      ]
    }
  },
  methods: {
    goToSelection(link) {
      window.open(link, '_blank');
    }
  }
}
</script>

<style scoped>
.selections-container-phone {
  gap: 40px;
  text-transform: capitalize !important;

  .img-selection {
    width: 350px;
    height: 195px;
    object-fit: cover;
  }

  .selection-section {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 30px;

    .item-link {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .raleway-bold-16{
    font-family: 'Raleway';
    font-weight: 700;
    font-size: 16px;
  }
}
</style>